export class ContractTransformer {
  static transform(obj) {
    const contract = Object.assign({}, obj.attributes, { id: obj.id });
    return contract;
  }
}
